import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';

export const funds_relocation_form_template = {
    TFRAllocation: '0',
    companyAllocation: '0',
    subscriberAllocation: '0',
}

export const INVESTMENT_FUNDS_REDIRECTION_TABLE_KEYS: ITableKey[] = [
  {
    key: 'description',
    label: 'Fondo',
  },
  {
    key: 'subscriberAllocation',
    label: 'Iscritto (%)',
  },
  {
    key: 'companyAllocation',
    label: 'Datore di Lavoro (%)',
  },
  {
    key: 'TFRAllocation',
    label: 'TFR (%)',
  },
];